import _get from 'lodash/get';


const getErrors = state => _get(state, 'siteTemplateConfiguration.errors');
export const getLoadTemplateConfigPreparationError = state => (
  _get(getErrors(state), 'loadTemplateConfigPreparationError')
);
export const getSetFileError = state => _get(getErrors(state), 'setFileError');
export const getResetFileError = state => _get(getErrors(state), 'resetFileError');
